import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, IconButton, Stack, styled, Typography } from '@mui/material'
import type { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import type { To } from 'react-router'
import { useNavigate } from 'react-router'

import { ICONS, LinkUnstyled, unit } from '@hcr/ui'

import { Path } from '../../../../../models'
import { to } from '../../../../../utils'
import { LayoutBase } from '../../../../common'

interface LayoutAccountEditInformationProps {
  button?: {
    label: string
    to: To
  }
  description: string
  headline: string
  image: ReactNode
}

export const LayoutAccountEditInformation: FC<LayoutAccountEditInformationProps> = ({
  button,
  description,
  headline,
  image,
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <LayoutBase>
      <Container>
        <StyledIconButton onClick={() => navigate(to(Path.Account))} aria-label={t('home.close')}>
          <FontAwesomeIcon icon={ICONS.farXmark} />
        </StyledIconButton>
        {image}
        <Content>
          <Typography component='h1' variant='titleM'>
            {headline}
          </Typography>
          <Typography component='h2' variant='bodyM'>
            {description}
          </Typography>
        </Content>
        {button && (
          <Button component={LinkUnstyled} to={button.to} variant='contained' color='primary'>
            {button.label}
          </Button>
        )}
      </Container>
    </LayoutBase>
  )
}

const Container = styled(Stack)`
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: ${unit(7)};
  padding: ${unit(7)};
`

const StyledIconButton = styled(IconButton)`
  align-self: flex-end;
  position: absolute;
  top: ${unit(6)};
  right: ${unit(6)};
  cursor: pointer;
  font-size: ${unit(6)};
`

const Content = styled(Stack)`
  align-items: center;
  gap: ${unit(2.5)};
  text-align: center;
`
